import { useState } from 'react';

/** Opt-in auto-refresh poll cadence (ms). The ONE source for every monitoring "Auto-refresh" toggle — there is
 * no live push channel, so views poll on this interval only when the user opts in. */
export const AUTO_REFRESH_MS = 60_000;

export interface AutoRefreshState {
	/** Whether the opt-in poll is currently on. Drives any "dim on refetch" overlay gate too (silent while on). */
	autoRefresh: boolean;
	setAutoRefresh: (next: boolean) => void;
	/** react-query `refetchInterval` to thread into the page's data hook(s): the shared cadence when on,
	 * `undefined` (polling disabled) when off. */
	refetchInterval: number | undefined;
}

/**
 * Opt-in auto-refresh state for a live monitoring view. Owns the on/off flag and maps it to the react-query
 * `refetchInterval` (the shared 60s cadence when on, `undefined` when off). Pair with `PunchupAutoRefreshToggle`
 * for the control and pass `refetchInterval` to the page's query hook(s). Off by default — there is no live push
 * channel, so polling is opt-in (see ScannedTickets/CLAUDE.md).
 */
export const useAutoRefresh = (initialOn = false): AutoRefreshState => {
	const [autoRefresh, setAutoRefresh] = useState(initialOn);
	return { autoRefresh, setAutoRefresh, refetchInterval: autoRefresh ? AUTO_REFRESH_MS : undefined };
};
